import Vue from 'vue'
import Vuex from 'vuex'
import { getUserInfoApi } from '@/api'

Vue.use(Vuex)  // 注册 Vuex

export default new Vuex.Store({
  state: {
    userInfo: {
      kyc: {},
      referral: '',
      inviter: '',
    },
    windowWidth: 1280,
  },
  mutations: {
    updateUserInfo (state, userInfo) {
      state.userInfo = userInfo
    },
    updateWindowWidth (state, width) {
      state.windowWidth = width
    }
  },
  actions: {
    getUserInfo({ commit }) {
      getUserInfoApi().then(res => {
        commit('updateUserInfo', res)
      })
    },
    setWindowWidth ({ commit }, width) {
      commit('updateWindowWidth', width)
    }
  },
  getters: {
    isChannel(state) {
      return state.userInfo.identity === 2
    },
    isMobile (state) {
      return state.windowWidth <= 500
    }
  }
})